import { ReactElement } from "react";
import { ButtonProps } from "../../interfaces/ComponentInterfaces";
import { ButtonType } from "../../enums/componentEnums";
import Loader from "../feedBacks/loader";
import { IconWrapper } from "../../customHooks/useIcon";

const AppButton = ({
  type,
  icon: Icon = null,
  iconPosition = "left",
  className = null,
  text,
  loader = null,
  handleClick,
  ...rest
}: ButtonProps): ReactElement => {
  return (
    <button
      type="submit"
      {...rest}
      onClick={(e) => {
        e.preventDefault();
        if (type !== ButtonType.DISABLED && !loader?.loading && handleClick) {
          handleClick();
        }
      }}
      className={`flex focus:outline-none gap-2 justify-center rounded-lg items-center text-center my-auto h-10 ${type} ${className}`}
    >
      {Icon ? (
        <>
          {iconPosition === "left" && <IconWrapper icon={Icon} size={14} />}
          {text}{" "}
          {loader?.loading && (
            <Loader  />
          )}{" "}
          {iconPosition === "right" && <IconWrapper icon={Icon} size={14} />}
        </>
      ) : loader?.loading ? (
        <>
          {text}
          <Loader  />
        </>
      ) : (
        text
      )}
    </button>
  );
};

export default AppButton;
